import { createModuleBuilder } from '@evidentid/dashboard-commons/app';
import { GatewayApiClient } from '@evidentid/gateway-api-client';
import Logger from '@evidentid/logger';
import Tracker from '@evidentid/tracker';

import ApiSettings from '@/modules/api-settings/views/ApiSettings.vue';
import { useApiSettingsStore } from '@/modules/api-settings/store';
import { observeTrackAndLogOnStore } from '@/utils/vuex-common/observeTrackAndLog';

const legacyRoutesRedirect = [
    {
        path: '/:rpId?/admin/api-settings',
        redirect: '/:rpId?/configuration/api-settings',
    },
];

function trackAndLog(app: any): void {
    const module = 'Api Settings';
    const store = useApiSettingsStore(app.getPinia());
    observeTrackAndLogOnStore(app, store,
        { start: 'startLoadingApiKey', finish: 'finishLoadingApiKey', fail: 'failLoadingApiKey' },
        { module, title: 'Api Key', action: 'Load' },
    );
    observeTrackAndLogOnStore(app, store,
        { start: 'startLoadingWebhooks', finish: 'finishLoadingWebhooks', fail: 'failLoadingWebhooks' },
        { module, title: 'Webhooks', action: 'Load' },
    );
    observeTrackAndLogOnStore(app, store,
        { start: 'startLoadingWebhookTypes', finish: 'finishLoadingWebhookTypes', fail: 'failLoadingWebhookTypes' },
        { module, title: 'WebhookTypes', action: 'Load' },
    );
    observeTrackAndLogOnStore(app, store,
        { start: 'startCreatingWebhook', finish: 'finishCreatingWebhook', fail: 'failCreatingWebhook' },
        { module, title: 'Webhook', action: 'Create' },
    );
    observeTrackAndLogOnStore(app, store,
        { start: 'startPatchingWebhook', finish: 'finishPatchingWebhook', fail: 'failPatchingWebhook' },
        { module, title: 'Webhook', action: 'Patch' },
    );
    observeTrackAndLogOnStore(app, store,
        { start: 'startDeletingWebhook', finish: 'finishDeletingWebhook', fail: 'failDeletingWebhook' },
        { module, title: 'Webhook', action: 'Delete' },
    );
}

export const apiSettingsModule = createModuleBuilder()
    .registerRoutes(() => [
        {
            path: '/:rpId?/configuration/api-settings',
            name: 'apiSettings',
            component: ApiSettings as any,
            meta: { title: 'API Settings', pageClass: 'ApiSettings' },
        },
        ...legacyRoutesRedirect,
    ])
    .demandContext<{
    gatewayClient: GatewayApiClient;
    tracker?: Tracker<any>;
    logger?: Logger<any>;
}>()
    .execute((app) => {
        trackAndLog(app);
    })
    .end();
